import orderOptimizerTranslationsHelper from "../../../../../languages/order-optimizer-translations.helper";
import OrderOptimizerRailyDetailsDriverTableColumn from "../common/types/order-optimizer-raily-details-driver-table-column";

const getColumns = (): OrderOptimizerRailyDetailsDriverTableColumn[] => {
  const translations =
    orderOptimizerTranslationsHelper.getRailyDetailsTranslations().table.driver
      .headers;

  const tableColumns: OrderOptimizerRailyDetailsDriverTableColumn[] = [
    {
      header: translations.driverLabel,
      title: translations.driverTitle,
      accessor: "driver",
      colSpan: 3,
    },
    {
      header: translations.billingModelLabel,
      title: translations.billingModelTitle,
      accessor: "billingModel",
      colSpan: 3,
    },
    {
      header: translations.contractRateLabel,
      title: translations.contractRateTitle,
      accessor: "contractRate",
      colSpan: 3,
    },
    {
      header: translations.totalTimeLabel,
      title: translations.totalTimeTitle,
      accessor: "totalTime",
      colSpan: 3,
    },
    {
      header: translations.haltingTimeLabel,
      title: translations.haltingTimeTitle,
      accessor: "haltingTime",
      colSpan: 3,
    },
    {
      header: translations.distanceLabel,
      title: translations.distanceTitle,
      accessor: "distance",
      colSpan: 3,
    },
    {
      header: translations.marginLabel,
      title: translations.marginTitle,
      accessor: "margin",
      colSpan: 4,
    },
  ];

  return tableColumns;
};

const orderOptimizerRailyDetailsDriverTableHelper = {
  getColumns,
};

export default orderOptimizerRailyDetailsDriverTableHelper;
